<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <vue-recaptcha
    :execute="execute"
    :sitekey="siteKey"
  />
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { GOOGLE } from '@config'

export default {
  name: 'ReCaptcha',
  components: { VueRecaptcha },
  props: {},
  data: () => ({ siteKey: GOOGLE.reCaptchaKey }),
  computed: {},
  methods: {
    execute () {
      // console.log(arguments)
    }
  }
}
</script>
